"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getBrowser() {
    // if not in a browser, assume we're in a test, return a dummy
    if (typeof window === 'undefined') {
        //@ts-ignore
        return {};
    }
    //@ts-ignore
    return require('webextension-polyfill');
}
exports.browser = getBrowser();
//# sourceMappingURL=index.js.map